module.exports = __webpack_public_path__ + "static/media/s1.559a8505.ogg";